import get from "lodash.get"

export function getMetadataType(storyMetadata){
    if(!storyMetadata) return ""
    return get(storyMetadata, 'type') || ""
}